import axios from "axios";
import { BASE_URL } from "../apis/backEnd.apis";
import { config } from "../config";
const token = config.apiAccessKey;

export const postCheckoutInfo = data =>
  axios.post(`${BASE_URL}donors/processDonation/`, data, {
    headers: { "access-token": `${token}` }
  });
